import { calendarsQueryOptions } from "@/api/calendars.api";
import { Calendars } from "@/components/calendars";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/calendars/")({
  component: () => <Calendars />,
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(calendarsQueryOptions),
});
